import { SUBSCRIBE } from "actions/subscribe.action";
import { FAVORITE_ADD, FAVORITE_REMOVE } from "actions/feed.favorite.action";
import produce from "immer";

const initialState = {
    loading: true,
    data: [],
    error: null
};

const subscribeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBSCRIBE.LOADING_START:
            return { ...state, loading: true };

        case SUBSCRIBE.LOADING_DONE:
            return { ...state, loading: false };

        case SUBSCRIBE.FETCH_SUCCESS:
            return { ...state, data: action.payload.data, error: null };

        case SUBSCRIBE.FETCH_ERROR:
            return { ...state, error: action.payload };


        case FAVORITE_ADD:
            return produce(state, (draftState) => {
                const index = draftState.data.findIndex(item => item.user_id === action.payload.user_id)
                if (index > -1) {
                    draftState.data[index].is_favorite = true;
                }
            });
        case FAVORITE_REMOVE:
            return produce(state, (draftState) => {
                const index = draftState.data.findIndex(item => item.user_id === action.payload.favorite_id)
                if (index > - 1) {
                    draftState.data[index].is_favorite = false;
                }
            });

        case SUBSCRIBE.FILTER_PIN:
            return produce(state, (draftState) => {
                const index = draftState.data.findIndex(item => item.subscribe_no === action.payload.no)
                if (index > - 1) {
                    draftState.data[index].is_pin = action.payload.flag;
                }
            });


        case SUBSCRIBE.UPDATE_SUBNICK:
            return produce(state, (draftState) => {
                const index = draftState.data.findIndex(item => item.user_id === action.payload.user_id)
                if (index > -1) {
                    draftState.data[index].sub_nick = action.payload.sub_nick;
                }
            });

        default:
            return state;
    }
};

export default subscribeReducer;
